<template>
  <!-- eslint-disable max-len -->
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card>
      <v-card-title class="primary">
        <span class="white--text">
          {{ $t('reportexport.dialog.title') }}
        </span>
      </v-card-title>
      <v-card-text style="height: 300px;" class="pt-0">
        <v-form ref="form" v-model="valid" lazy-validation class="mt-5">
          <v-autocomplete
            class="mt-0"
            clearable
            filled
            :label="$t('reportexport.dialog.reportname')"
            :items="reportlist"
            return-object
            v-model="reportexportobj.report"
            item-text="name"
            item-value="name"
            :rules="rules.report"
          >
          <template #item="{ item }">
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <v-list-item-title v-text="item.description_cn"></v-list-item-title>
              <v-list-item-title v-text="item.description_en"></v-list-item-title>
            </v-list-item-content>
          </template>
          </v-autocomplete>
          <v-text-field
            clearable
            filled
            :label="$t('reportexport.dialog.startdate')"
            v-model="reportexportobj.startdate"
            type="date"
            :rules="rules.startdate"
          >
          </v-text-field>
          <v-text-field
            clearable
            filled
            :label="$t('reportexport.enddate')"
            v-model="reportexportobj.enddate"
            type="date"
            :rules="rules.enddate"
          >
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text class="text-none" @click="dialog = false">
          {{ $t('reportexport.cancelbtn') }}
        </v-btn>
        <v-btn
          color="primary"
          class="text-none"
          :loading="saving"
          :disabled="savedisabled"
          @click="submit"
        >
          {{ $t('reportexport.savebtn') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      reportexportobj: {},
      rules: {
        report: [(v) => !!v || this.$t('reportexport.dialog.reportrequired')],
        startdate: [(v) => !!v || this.$t('reportexport.dialog.startdaterequired')],
        enddate: [(v) => !!v || this.$t('reportexport.dialog.enddate')],
      },
      valid: false,
      saving: false,
    };
  },
  props: ['reportlist', 'showParamDialog'],
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapActions('reportExport', ['getElement', 'postElement', 'updateElement', 'executeReportFile']),
    ...mapActions('user', ['getMe']),
    async submit() {
      const { reportexportobj } = this;
      const {
        report,
      } = reportexportobj;
      let {
        startdate,
        enddate,
      } = reportexportobj;
      startdate = Number(startdate.split('-').join(''));
      enddate = Number(enddate.split('-').join(''));
      if (enddate < startdate) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('reportexport.endtimeerrortext'),
        });
        return;
      }
      const {
        name,
        description_cn: descriptioncn,
        description_en: descriptionen,
      } = report;
      const payload = {
        reportname: name,
        reportdescription_cn: descriptioncn,
        reportdescription_en: descriptionen,
        startdate,
        enddate,
        status: 0,
        user: this.me.user.lastname + this.me.user.firstname,
        assetid: 4,
      };
      this.saving = true;
      const postData = {
        elementname: 'reportexport',
        payload,
      };
      const elementid = await this.postElement(postData);
      this.saving = false;
      if (elementid) {
        const reportpayload = {
          start: startdate,
          end: enddate,
          siteid: this.me.activeSiteId,
          elements: name,
          queryId: elementid,

        };
        const postfileresult = await this.executeReportFile({ payload: reportpayload });
        console.log(postfileresult, 'postfileresult');
        if (postfileresult) {
          console.log(reportpayload, 'reportpayload');
          this.setAlert({
            show: true,
            type: 'success',
            message: this.$t('reportexport.createdsuccesstext'),
          });
          this.$emit('cancel');
          this.$emit('search', payload);
        }
      } else {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('reportexport.createderrortext'),
        });
      }
    },
  },
  computed: {
    ...mapState('user', ['me']),
    dialog: {
      get() {
        return this.showParamDialog;
      },
      set() {
        console.log(this.me.activeSiteId, 'activeSiteId');
        this.reportexportobj = {};
        this.$refs.form.resetValidation();
        this.$emit('cancel');
      },
    },
    savedisabled() {
      const {
        valid,
        reportexportobj,
      } = this;
      const {
        report,
        startdate,
        enddate,
      } = reportexportobj;
      return !valid || !report || !startdate || !enddate;
    },
  },
};
</script>
